import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class SnackBarInterceptor implements HttpInterceptor {
    constructor(private snackBar: MatSnackBar) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            tap((e) => {
                if ((request.method == 'POST' || request.method == 'PUT' || request.method == 'PATCH') && !request.url.includes('login'))
                    if (e instanceof HttpResponse && e.status == 200) {
                        this.snackBar.open('Erfolgreich gespeichert.', '', {
                            duration: 5000,
                            panelClass: 'green-snackbar',
                            verticalPosition: 'top',
                            horizontalPosition: 'center',
                        });
                    }
            }),
            catchError((error) => {
                if (error.status != 404) {
                    const errorMessage = error?.error[0]?.value ?? 'Vorgang nicht möglich. Bitte versuchen Sie erneut.';
                    this.snackBar.open(errorMessage, '', {
                        duration: 5000,
                        panelClass: 'red-snackbar',
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                    });
                }
                return throwError(error);
            }),
        );
    }
}
